import { motion } from "framer-motion";
import { Img } from "./Img";

const CHAPTERS = [
  {
    num: "01",
    title: "The Method",
    body: "Precise, relentless. Every Sculpt Fusion class fuses classical mat Pilates with sculpting resistance work — deliberate reps that fire deep into the core and hold you at the edge of the burn.",
    img: "m1",
  },
  {
    num: "02",
    title: "The Room",
    body: "One intimate studio drenched in hot-pink glow. Sixteen mats — just breath, beat and a coach who knows your name and your limits.",
    img: "m2",
  },
  {
    num: "03",
    title: "The Result",
    body: "Longer lines. A steadier core. A body that moves like it means it. Show up three times a week and watch strength become second nature.",
    img: "m3",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } },
};

export const Manifesto = () => {
  return (
    <section id="about" data-testid="manifesto" className="relative bg-black py-24 sm:py-32">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <motion.div
          variants={reveal}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
          className="mb-20 max-w-3xl"
        >
          <p className="text-xs uppercase tracking-[0.35em] text-neon mb-5">The Manifesto</p>
          <h2 className="font-display uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.9]">
            We don't do <span className="font-script normal-case neon-text">gentle</span> —<br />we do results.
          </h2>
        </motion.div>

        <div className="flex flex-col gap-24 sm:gap-32">
          {CHAPTERS.map((c, i) => (
            <div
              key={c.num}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center ${
                i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""
              }`}
            >
              <motion.div
                initial={{ opacity: 0, scale: 1.08 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
                className="relative overflow-hidden aspect-[4/5] border border-neutral-900"
              >
                <Img name={c.img} alt={c.title} sizes="(max-width: 640px) 100vw, 50vw" className="w-full h-full object-cover scale-100 hover:scale-105 transition-transform duration-700" />
                <span className="absolute top-4 left-4 font-display text-6xl neon-text">{c.num}</span>
              </motion.div>

              <motion.div
                variants={reveal}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-80px" }}
              >
                <h3 className="font-display uppercase text-4xl sm:text-5xl mb-6">{c.title}</h3>
                <p className="text-base lg:text-lg text-neutral-400 font-light leading-relaxed max-w-lg">
                  {c.body}
                </p>
              </motion.div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
